import { GroupTravelStaticAlert } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/GroupTravelStaticAlert";
import {
  AltTransTrainEvent,
  AltTransTrainId,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";
import { useTrainInformation } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/useTrainInformation";
import { FC, useMemo } from "react";
import { ContentLoader, Button, Text } from "shared/components/Spor";
import { isNotNullish } from "shared/utils/objectUtils";

type GroupTravelStaticAlertsProps = {
  events: Array<AltTransTrainEvent>;
  trainId: AltTransTrainId;
};

export const GroupTravelStaticAlerts: FC<GroupTravelStaticAlertsProps> = ({
  events,
  trainId: { id, nominalDate, countryCode },
}) => {
  const groupTravelEventIds = useMemo(
    () =>
      events
        .filter((event) => event.type === TrainEventTypeEnum.TRAIN_GROUP_TRAVEL)
        .map((event) => event.id),
    [events],
  );

  const response = useTrainInformation(id, nominalDate, countryCode);

  const groupTravelEvents = useMemo(
    () =>
      response.data
        ? response.data
            .filter((info) => groupTravelEventIds.includes(info.latestInfoUuid))
            .map((info) =>
              info.versions.find(
                (version) => version.uuid === info.latestInfoUuid,
              ),
            )
            .filter(isNotNullish)
        : [],
    [response.data, groupTravelEventIds],
  );

  if (!groupTravelEventIds.length) {
    return null;
  }

  if (response.status === "pending") {
    return <ContentLoader />;
  }

  if (response.status === "error" || groupTravelEvents.length === 0) {
    return (
      <div>
        <Text>
          Kunne ikke hente detaljer for {groupTravelEventIds.length}{" "}
          gruppereiser.
        </Text>
        <Button variant="primary" size="sm" onClick={() => response.refetch()}>
          Prøv igjen
        </Button>
      </div>
    );
  }

  return groupTravelEvents.map((event) => (
    <GroupTravelStaticAlert key={event.uuid} event={event} />
  ));
};
